<template>
  <v-app dark>
    <app-toolbar />
    <app-user-modal />
    <app-confirm-modal />
    <app-param-search-modal />
    <app-messenger />
    <app-footer />
    <app-scroll-top-btn />

    <v-content>
      <!-- TODO: Dynamic breadcrumbs component e.g. https://jsfiddle.net/Linusborg/fgporeLx/ or https://medium.com/@fagnersaraujo/automated-breadcrumbs-with-vuejs-7e1051de8028 -->
      <transition
        name="fade"
        mode="out-in"
      >
        <keep-alive exclude="Search,paramSearch,Movie,Person,TVShow,DetailsModal,SeasonDetail,Test">
          <router-view />
        </keep-alive>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar.vue';
import UserModal from './components/UserModal.vue';
import ConfirmModal from './components/ConfirmModal.vue';
import Footer from './components/Footer.vue';
import paramModal from './components/paramSearchModal.vue';
import Messenger from './components/Messenger.vue';
import SrcollTopBtn from './components/ScrollTopBtn.vue';

export default {
  name: 'App',
  components: {
    appToolbar: Toolbar,
    appUserModal: UserModal,
    appConfirmModal: ConfirmModal,
    appParamSearchModal: paramModal,
    appMessenger: Messenger,
    appFooter: Footer,
    appScrollTopBtn: SrcollTopBtn,
  },
};
</script>

<style lang="scss">
body {
  min-width: 320px;
}

.container {
  @media (min-width: 1903px) {
    max-width: 1250px;
    margin: 0 auto;
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  // transition: opacity 0.25s;
}

.fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  // transition: opacity 0.25s;
  opacity: 0;
}

.breadcrumbs {
  a {
    color: #e1e1e1 !important;
  }
}

.v-breadcrumbs {
  padding: 0 !important;
  padding-left: 18px !important;

  @media (max-width: 960px) {
    padding-left: 10px !important;
  }

  @media (max-width: 600px) {
    display: none !important;
  }
}
</style>
